import * as Types from '../types-api.generated';

import { EditionSaleConfigurationFragment, MediaFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldEditionsVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  status?: Types.InputMaybe<Types.ApiEditionStatus>;
  accountAddress?: Types.InputMaybe<Types.Scalars['ID']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiWorldEditions = { worldEditions: { editions: { totalItems: number, page: number, totalPages: number, items: Array<{ name: string, id: string, nftCount: number, slug: string, assetUrl: string | null, chainId: ChainId, contractAddress: Address, mimeType: string | null, contractType: Types.ApiContractType, creator: { profileImageUrl: string | null, username: string | null, name: string | null, publicKey: Address }, saleConfiguration: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } }> }, editionCounts: { scheduledCount: number, openCount: number, endedCount: number } } };



export const ApiWorldEditionsDocument = /*#__PURE__*/ `
    query WorldEditions($id: Int!, $status: EditionStatus, $accountAddress: ID, $page: Int, $perPage: Int) {
  worldEditions: editionsByExhibition(
    exhibitionId: $id
    status: $status
    accountAddress: $accountAddress
    page: $page
    perPage: $perPage
  ) {
    editions {
      totalItems
      page
      totalPages
      items {
        name
        id
        nftCount
        slug
        assetUrl
        chainId
        contractAddress
        mimeType
        contractType
        creator {
          profileImageUrl
          publicKey: accountAddress
          username
          name
        }
        saleConfiguration {
          ...EditionSaleConfigurationFragment
        }
      }
    }
    editionCounts {
      scheduledCount
      openCount
      endedCount
    }
  }
}
    ${EditionSaleConfigurationFragment}`;

export const useWorldEditions = <
      TData = ApiWorldEditions,
      TError = ClientError
    >(
      variables: ApiWorldEditionsVariables,
      options?: Omit<UseQueryOptions<ApiWorldEditions, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldEditions, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldEditions, TError, TData>(
      {
    queryKey: ['WorldEditions', variables],
    queryFn: apiFetcher<ApiWorldEditions, ApiWorldEditionsVariables>(ApiWorldEditionsDocument, variables),
    ...options
  }
    )};

useWorldEditions.getKey = (variables: ApiWorldEditionsVariables) => ['WorldEditions', variables];

export const useInfiniteWorldEditions = <
      TData = InfiniteData<ApiWorldEditions>,
      TError = ClientError
    >(
      variables: ApiWorldEditionsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldEditions, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldEditions, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldEditions, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldEditions.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldEditions, ApiWorldEditionsVariables>(ApiWorldEditionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldEditions.getKey = (variables: ApiWorldEditionsVariables) => ['WorldEditions.infinite', variables];


useWorldEditions.fetcher = (variables: ApiWorldEditionsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldEditions, ApiWorldEditionsVariables>(ApiWorldEditionsDocument, variables, options);
